import { RiotLogo } from "./icons/RiotLogo";
import { Icon } from "@ugitgud/legos/ui/icon/Icon";
import { UGGLogoFull } from "@ugitgud/legos/ui/icon/UGGLogoFull";
import { SvgUggLogoU } from "@ugitgud/legos/ui/icon/SVG/UggLogoU";
import { FeatureHighlightsBox, PLUS_FEATURE_ICONS, PLUS_FEATURE_DATA } from "@ugitgud/legos/components/plus/PlusFeatures";

const DEFAULT_UTM_SOURCE = "ugghome";
const DEFAULT_UTM_CAMPAIGN = "homefeatured";

const featureHighlights = [
  {
    icon: <img src={PLUS_FEATURE_ICONS.adFree} alt="Ad-Free" className="w-[70px] h-auto" />,
    ...PLUS_FEATURE_DATA.adFree,
  },
  {
    icon: <img src={PLUS_FEATURE_ICONS.profiles} alt="Profiles PLUS" className="w-[56px] h-auto" />,
    ...PLUS_FEATURE_DATA.profiles,
  },
  {
    icon: <img src={PLUS_FEATURE_ICONS.sharedSocials} alt="Shared Socials" className="w-[86px] h-auto" />,
    ...PLUS_FEATURE_DATA.sharedSocials,
  },
  {
    icon: (
      <div className="relative">
        <img src={PLUS_FEATURE_ICONS.support} alt="Priority Support" className="w-[70px] h-auto" />
        <SvgUggLogoU className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[25px] h-auto" />
      </div>
    ),
    ...PLUS_FEATURE_DATA.support,
  },
];

export function FeaturedUggPlus({
  utmSource = DEFAULT_UTM_SOURCE,
  utmCampaign = DEFAULT_UTM_CAMPAIGN,
}: {
  utmSource?: string;
  utmCampaign?: string;
}) {
  const checkoutUrl = `/plus?utm_source=${utmSource}&utm_campaign=${utmCampaign}`;

  return (
    <div className="flex items-center flex-row flex-nowrap gap-[63px] justify-between mt-16 sm:mt-[180px] max-w-[1016px] w-full mx-auto px-3 lg:px-0">
      {/* Left side - U.GG PLUS branding */}
      <div className="flex flex-col shrink-0 w-[332px]">
        <p className="text-[18px] font-bold mb-4 text-white">Featured U.GG Product</p>
        <div className="flex items-center flex-row flex-nowrap gap-[9.77px] mb-3">
          <Icon icon={<UGGLogoFull />} className="w-[93.42px] h-auto" />
          <span className="rounded-[6.185px] text-[18.554px] font-bold border-[2px] border-accent-yellow-400 px-2 py-0.5 bg-accent-brown-400 text-accent-yellow-400">
            PLUS
          </span>
        </div>
        <p className="text-[#8E8EB5] text-[14px] font-normal mb-6 leading-snug">
          Experience ad-free, enhanced profiles, shared socials, and more.
        </p>
        <a
          href={checkoutUrl}
          className="group relative flex items-center justify-center rounded-[3px] h-10 w-[180px] bg-accent-brown-400 border border-accent-yellow-400 text-white text-[14px] font-semibold transition-all mb-4"
        >
          <span
            className="absolute inset-0 rounded-[3px] opacity-0 group-hover:opacity-100 transition-opacity"
            style={{
              background: "linear-gradient(0deg, rgba(244, 200, 116, 0.05) 0%, rgba(244, 200, 116, 0.05) 100%), #25254B",
            }}
          />
          <span className="relative">
            Start Your&nbsp;<span className="text-accent-yellow-400 font-bold">Free</span>&nbsp;Trial
          </span>
        </a>
        <div className="flex items-center flex-row flex-nowrap gap-2 text-[11px] font-normal text-[#5c5c8e]">
          <RiotLogo className="w-5 min-w-5 fill-[#5c5c8e]" /> Fully compliant with Riot Games
        </div>
      </div>

      {/* Right side - Feature highlights box */}
      <FeatureHighlightsBox
        featureHighlights={featureHighlights}
        className="flex-1"
        innerClassName="py-[32px] px-[36px]"
        gridClassName="grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[36px]"
        cardIconHeight="h-[70px]"
        cardTitleClassName="text-[13px] font-bold text-center text-white"
        cardDescriptionClassName="text-[11px] text-[#8E8EB5] text-center leading-tight"
      />
    </div>
  );
}
